import { routes as app } from "@/router/routes/app";

export const routes = [...app];
